import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgEaster = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.417 7.657q.325-.498.687-.964c.748-.967 1.572-1.782 2.367-2.35.81-.578 1.511-.843 2.027-.843s1.217.265 2.028.844c.794.567 1.619 1.382 2.366 2.349.704.91 1.317 1.921 1.771 2.947l-13.16 3.676-.003-.222c0-1.123.337-2.371.896-3.594l8.59-2.402a.75.75 0 0 0-.404-1.445zm-1.773 7.177c.24 1.389.775 2.6 1.588 3.534 1.124 1.292 2.844 2.132 5.266 2.132s4.142-.84 5.266-2.132a6.6 6.6 0 0 0 1.237-2.168l-9.899 2.768a.75.75 0 1 1-.404-1.444L19.4 14.53q.096-.694.096-1.437c0-.648-.112-1.338-.315-2.04zM12.498 2c-.969 0-1.979.466-2.9 1.123-.936.669-1.863 1.595-2.68 2.652C5.297 7.868 4 10.613 4 13.095c0 2.384.67 4.613 2.1 6.258C7.546 21.013 9.7 22 12.499 22c2.799 0 4.953-.987 6.398-2.647 1.43-1.645 2.1-3.874 2.1-6.259 0-2.48-1.297-5.226-2.917-7.32-.818-1.056-1.745-1.982-2.682-2.651C14.477 2.466 13.467 2 12.498 2"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgEaster;
